// extracted by mini-css-extract-plugin
export default {"header":"TheHeader_header__qUr5y","row":"TheHeader_row__6LS+D"};